import React from "react";
import loadingSpinner from "../../../assets/images/LoadingSpinner.gif";
import tickIcon from "../../../assets/svg/tick.svg";
import { ordinalSuffix } from "../../../utils/formatDateTime";
import useWindowWidth from "../../../hooks/useWindowWidth";
import Modal from "../../../components/common/Modal";

const ApprovalLogModal = ({
  setShowApprovalLogModal,
  approvalLogData = null,
  approvalLogLoading = false,
}: {
  setShowApprovalLogModal: (value: boolean) => void;
  approvalLogData?: any;
  approvalLogLoading?: boolean;
}) => {
  const windowWidth = useWindowWidth();

  // Use the actual data passed from parent or fallback to empty array
  const history = approvalLogData || [];

  return (
    <Modal
      header="Approval Log"
      clickOutsideToClose
      handleCancel={() => {
        setShowApprovalLogModal(false);
      }}
      minHeight="50vh"
    >
      <div className="w-full">
        <div className="h-full w-full px-4 ">
          {approvalLogLoading ? (
            <div className="min-h-[70dvh] flex justify-center items-center ">
              <img
                src={loadingSpinner}
                alt="spinner"
                className="h-[20%] w-[20%]"
              />
            </div>
          ) : (
            <div className=" flex flex-col h-[40vh] w-full  overflow-y-scroll custom-scrollbar">
              <div className="relative pt-[10px] w-full pr-4">
                {history.length > 0 &&
                  history?.map((el: any, i: any) => {
                    const date = new Date(el.created_at);
                    const day = String(date.getDate()).padStart(2, "0");
                    const month = date.toLocaleString("default", {
                      month: "short",
                    });
                    const year = date.getFullYear().toString().slice(-2);

                    const hours = String(date.getHours() % 12 || 12).padStart(
                      2,
                      "0"
                    );
                    const minutes = String(date.getMinutes()).padStart(2, "0");
                    const ampm = date.getHours() < 12 ? "AM" : "PM";

                    const formattedDate = `${day}${ordinalSuffix(
                      day
                    )} ${month} '${year} | ${hours}:${minutes} ${ampm}`;

                    return (
                      <div
                        key={i}
                        className="flex  justify-start items-start text-start w-full  gap-3 relative "
                      >
                        <div className="flex flex-col items-center z-10">
                          <>
                            <img
                              src={tickIcon}
                              alt="tick-icon"
                              className="w-[20px] h-[20px] "
                            />
                          </>
                        </div>

                        <div className="text-sm flex flex-col gap-1 w-full  h-auto">
                          <div
                            className={`flex justify-between text-sm leading-5  ${
                              windowWidth > 1240
                                ? "flex-row flex flex-wrap"
                                : "flex-col"
                            }`}
                          >
                            <div className="flex gap-1 ">
                              <p className="font-gilroy-medium font-sm text-[#1C1C1C] leading-[20px]">
                                Status changed to{" "}
                              </p>
                              <p
                                className={`w-fit border-none pt-0.5 text-black rounded-md text-[12px] px-2 cursor-pointer font-gilroy-regular text-center ml-2 ${
                                  el.status === "CHANGE_REQUESTED"
                                    ? "bg-[#BFB2FF]"
                                    : el.status === "IN_REVIEW"
                                    ? "bg-[#FFC5EF]"
                                    : el.status === "APPROVED"
                                    ? "bg-[#B6FDC6]"
                                    : el.status === "REJECTED"
                                    ? "bg-[#FFB4A1]"
                                    : ""
                                } `}
                                title={el.status.replace(/_/g, " ")} // Add the title attribute
                              >
                                {el.status.replace(/_/g, " ")}
                              </p>
                            </div>

                            <div className="">
                              <p
                                key={el.id}
                                className="text-[#AEAEAE] text-[12px] font-gilroy-regular leading-[20px]"
                              >
                                {formattedDate}
                              </p>
                            </div>
                          </div>
                          {el.review_comments ? (
                            <p
                              className={`text-sm font-gilroy-regular text-[#979797] leading-5 w-[100%] h-auto break-words pb-5
                       `}
                            >
                              {el.review_comments}{" "}
                            </p>
                          ) : (
                            <div className="h-[30px]"> </div>
                          )}
                        </div>
                      </div>
                    );
                  })}

                {history.length > 0 && (
                  <div className="absolute -top-[10px] left-[9px] w-[2px] h-[calc(100%-20px)] bg-[#DEDEDE]"></div>
                )}
              </div>

              {history.length === 0 && (
                <div className="min-h-[80%]  grid place-items-center">
                  <p className="text-center">No Logs</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ApprovalLogModal;
